import React from 'react';
import { FieldGroup, PeriscopeFieldGroup } from './';

export interface PeriscopeNodeGroupListProps {
	groups: FieldGroup[];
	parentIndex: number;
	showParents?: boolean;
	useApiNames: boolean;
}

export const PeriscopeFieldGroupList: React.FC<PeriscopeNodeGroupListProps> = ({ groups, ...rest }) =>
	<>
		{ groups.map((group, index) => {
			const key = `${index}-${group.name}`;

			return <PeriscopeFieldGroup
				group={ group }
				key={ key }
				{ ...rest } />;
		}) }
	</>;

